import { connect } from 'react-redux'
import { tabClicked } from 'utils/actions/ui'
import { filtersUpdate } from 'apps/booking/utils/actions/filters'
import { getShipmentCounts } from 'apps/booking/utils/actions/shipmentsStats'
import { Booking } from './Booking'
import { BookingFilters } from './BookingFilters'

export const ConnectedBookingFilters = connect(
  state => {
    const {
      shipments: { params, filterOptions: { amGroups } = {} },
      ui: { selectedTabIndex },
      filters,
    } = state
    return {
      selectedTabIndex,
      params,
      amGroups,
      filters,
    }
  },
  dispatch => ({
    tabClicked: (i, tabs) => dispatch(tabClicked(i, tabs)),
    getStatsCount: parameters => dispatch(getShipmentCounts(parameters)),
    filtersUpdate: filters => dispatch(filtersUpdate(filters)),
  })
)(BookingFilters)

export default Booking
